<template>
  <BaseTable
      :title="$t('history')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="HistoryListQueryDTO"
      dto-save-list-model="HistorySaveListCommandDTO"
      store-name="HistoryTable"
      new-item-component="HistoryItem"
      new-item-pass="/History/HistoryItem"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
  >
    <template v-slot:top.right="instance"><span></span></template>
    <template v-slot:item.uid="{ item }">
      <router-link :to="{name:'HistoryItem', params: { itemUid: item.uid}}">
        <span v-if="item.uid">{{ item.uid }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'HistoryTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false}
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "history": "History",
    "columns": {
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "version": "ver",
      "source_uid": "Source UUID",
      "source_name": "Source name",
      "source_version": "Source ver.",
      "item_hash": "Hash",
      "created_by": "Created by",
      "created_by_name": "Created by",
      "created_on": "Created on",
      "edited_by": "Edited by",
      "edited_by_name": "Edited by",
      "edited_on": "Edited on"
    }
  },
  "de": {
    "history": "Geschichte",
    "columns": {
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "version": "ver",
      "source_uid": "Quell UUID",
      "source_name": "Quell name",
      "source_version": "Quell ver.",
      "item_hash": "Hash",
      "created_by": "Erstellt von",
      "created_by_name": "Erstellt von",
      "created_on": "Erstellt am",
      "edited_by": "Bearbeitet von",
      "edited_by_name": "Bearbeitet von",
      "edited_on": "Bearbeitet am"
    }
  }
}
</i18n>
